export default __webpack_public_path__ + "static/media/heroImg.dccf9c9d.png";